import React, { useState } from 'react';
import { Badge, Fab, Menu, MenuItem, ListItemAvatar, Avatar, ListItemText, Typography } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { CONTEXTS } from 'figshelf-modules';
import { useChatPopup } from '../../contexts/ChatPopupContext';

/**
 * Floating test button to quickly open chat popups
 * Shows recent conversations in a menu
 */
const ChatPopupTestButton = () => {
  const { isSignedIn, isLoading } = CONTEXTS.useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const { openChat } = useChatPopup();
  const { conversations, totalUnreadCount } = CONTEXTS.useMessages();
  const location = useLocation();

  const recentChats = conversations?.slice(0, 5) || [];

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenChat = (conversationId) => {
    openChat(conversationId);
    handleClose();
  };

  if (isLoading) {
    return null;
  }

  if (!isSignedIn) {
    return null;
  }

  // Hide on messages and archived messages pages
  if (location.pathname === '/messages' || location.pathname === '/archived-messages') {
    return null;
  }

  if (recentChats.length === 0) {
    return null;
  }

  return (
    <>
        <Badge
          badgeContent={totalUnreadCount}
          color='error'
          overlap="circular"
          invisible={!totalUnreadCount || totalUnreadCount <= 0}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{
            position: 'fixed',
            bottom: 30,
            right: 20,
            zIndex: 5000,
            '& .MuiBadge-badge': {
              fontSize: '0.75rem',
              height: 18,
              minWidth: 18,
              
            },
          }}
        >
          <Fab
            color="primary"
            onClick={handleClick}
            sx={{zIndex: -1}}
          >
            <ChatIcon />
          </Fab>
        </Badge>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem disabled>
          <Typography variant="caption" color="text.secondary">
            Quick Open Chat Popup
          </Typography>
        </MenuItem>
        {recentChats.map((conv) => {
          const name = conv.name || 'Conversation';
          const avatar = conv.avatar || null;

          return (
            <MenuItem
              key={conv.id}
              onClick={() => handleOpenChat(conv.id)}
            >
              <ListItemAvatar>
                <Avatar src={avatar} sx={{ width: 32, height: 32 }}>
                  {name[0]}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={name}
                secondary={conv.lastMessage?.content?.substring(0, 30)}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ChatPopupTestButton;
